import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { IFetchService, PostConfigObject } from "app/services/fetchService";

import type { ILeadScoringSummaryDto, ILeadScoringSummaryPayload } from "../../types/leadScoring";

export default function createLeadScoringAgentApiService(apiClient: IFetchService) {
    return {
        fetchSummary: (
            payload: ILeadScoringSummaryPayload,
            options?: Readonly<PostConfigObject>,
        ): Promise<ILeadScoringSummaryDto> => {
            return apiClient.post(`${SALES_API_BASE_URL}/lead-scoring/summary`, payload, options);
        },
    };
}
